<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-payment-report`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M33.027 23.21l.094.083 2.914 2.913 2.915-2.913a1 1 0 011.414 0l1.414 1.414a1 1 0 010 1.414l-3.465 3.464H42a1 1 0 011 1v2a1 1 0 01-1 1h-4v2h4a1 1 0 011 1v2a1 1 0 01-1 1h-4v3a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3h-4a1 1 0 01-1-1v-2a1 1 0 011-1h4v-2h-4a1 1 0 01-1-1v-2a1 1 0 011-1h3.756l-3.463-3.464a1 1 0 01-.083-1.32l.083-.094 1.414-1.414a1 1 0 011.32-.083zM41 4a2 2 0 012 2v11h-4V8H9v31h14v4H7a2 2 0 01-2-2V6a2 2 0 012-2h34zM21 24a1 1 0 011 1v2a1 1 0 01-1 1h-7a1 1 0 01-1-1v-2a1 1 0 011-1h7zm5-8a1 1 0 011 1v2a1 1 0 01-1 1H14a1 1 0 01-1-1v-2a1 1 0 011-1h12z"/></svg>
</template>
<script>

export default {
  name: 'IconPaymentReport',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
